interface ExtensionMimeType {
  [key: string]: string;
}
export const extensionMimeMap: ExtensionMimeType = {
  "3g2": "video/3gpp2, audio/3gpp2",
  "3gp": "video/3gpp, audio/3gpp",
  "7z": "application/x-7z-compressed",
  aac: "audio/aac",
  abw: "application/x-abiword",
  arc: "application/x-freearc",
  avi: "video/x-msvideo",
  azw: "application/vnd.amazon.ebook",
  bin: "application/octet-stream",
  bmp: "image/bmp",
  bz: "application/x-bzip",
  bz2: "application/x-bzip2",
  csh: "application/x-csh",
  css: "text/css",
  csv: "text/csv",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  eot: "application/vnd.ms-fontobject",
  epub: "application/epub+zip",
  gif: "image/gif",
  gz: "application/gzip",
  htm: "text/html",
  html: "text/html",
  ico: "image/vnd.microsoft.icon",
  ics: "text/calendar",
  jar: "application/java-archive",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  js: "text/javascript",
  json: "application/json",
  jsonld: "application/ld+json",
  mid: "audio/midi audio/x-midi",
  midi: "audio/midi audio/x-midi",
  mjs: "text/javascript",
  mp3: "audio/mpeg",
  mp4: "video/mp4",
  mpeg: "video/mpeg",
  mpkg: "application/vnd.apple.installer+xml",
  odp: "application/vnd.oasis.opendocument.presentation",
  ods: "application/vnd.oasis.opendocument.spreadsheet",
  odt: "application/vnd.oasis.opendocument.text",
  oga: "audio/ogg",
  ogv: "video/ogg",
  ogx: "application/ogg",
  opus: "audio/opus",
  otf: "font/otf",
  pdf: "application/pdf",
  php: "application/x-httpd-php",
  png: "image/png",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  rar: "application/vnd.rar",
  rtf: "application/rtf",
  sh: "application/x-sh",
  svg: "image/svg+xml",
  swf: "application/x-shockwave-flash",
  tar: "application/x-tar",
  tif: "image/tiff",
  tiff: "image/tiff",
  ts: "video/mp2t",
  ttf: "font/ttf",
  txt: "text/plain",
  vsd: "application/vnd.visio",
  wav: "audio/wav",
  weba: "audio/webm",
  webm: "video/webm",
  webp: "image/webp",
  woff: "font/woff",
  woff2: "font/woff2",
  xhtml: "application/xhtml+xml",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xml: "application/xml, text/xml",
  xul: "application/vnd.mozilla.xul+xml",
  zip: "application/zip, application/x-zip, application/x-zip-compressed",
};

export function getFileExtension(name: string): string {
  const sp = name.split(".");
  return sp[sp.length - 1];
}

export function getFileName(name: string): string {
  switch (getFileExtension(name)) {
    case ".xls":
    case ".xlsx":
      return "excel file";
    case ".pdf":
      return "pdf file";
    case ".png":
    case ".jpg":
    case ".jpeg":
      return "image file";
    case ".doc":
    case ".docx":
      return "document file";
    case ".7z":
    case ".bz":
    case ".bz2":
    case ".gz":
    case ".rar":
    case ".zip":
      return "zip file";
    default:
      return "file";
  }
}

export function getFileType(name: string): string {
  switch (getFileExtension(name)) {
    case "3g2":
      return "video/3gpp2 audio/3gpp2";
    case "3gp":
      return "video/3gpp audio/3gpp";
    case "7z":
      return "application/x-7z-compressed";
    case "aac":
      return "audio/aac";
    case "abw":
      return "application/x-abiword";
    case "arc":
      return "application/x-freearc";
    case "avi":
      return "video/x-msvideo";
    case "azw":
      return "application/vnd.amazon.ebook";
    case "bin":
      return "application/octet-stream";
    case "bmp":
      return "image/bmp";
    case "bz":
      return "application/x-bzip";
    case "bz2":
      return "application/x-bzip2";
    case "csh":
      return "application/x-csh";
    case "css":
      return "text/css";
    case "csv":
      return "text/csv";
    case "doc":
      return "application/msword";
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "eot":
      return "application/vnd.ms-fontobject";
    case "epub":
      return "application/epub+zip";
    case "gif":
      return "image/gif";
    case "gz":
      return "application/gzip";
    case "htm":
      return "text/html";
    case "html":
      return "text/html";
    case "ico":
      return "image/vnd.microsoft.icon";
    case "ics":
      return "text/calendar";
    case "jar":
      return "application/java-archive";
    case "jpeg":
      return "image/jpeg";
    case "jpg":
      return "image/jpeg";
    case "js":
      return "text/javascript";
    case "json":
      return "application/json";
    case "jsonld":
      return "application/ld+json";
    case "mid":
      return "audio/midi audio/x-midi";
    case "midi":
      return "audio/midi audio/x-midi";
    case "mjs":
      return "text/javascript";
    case "mp3":
      return "audio/mpeg";
    case "mp4":
      return "video/mp4";
    case "mpeg":
      return "video/mpeg";
    case "mpkg":
      return "application/vnd.apple.installer+xml";
    case "odp":
      return "application/vnd.oasis.opendocument.presentation";
    case "ods":
      return "application/vnd.oasis.opendocument.spreadsheet";
    case "odt":
      return "application/vnd.oasis.opendocument.text";
    case "oga":
      return "audio/ogg";
    case "ogv":
      return "video/ogg";
    case "ogx":
      return "application/ogg";
    case "opus":
      return "audio/opus";
    case "otf":
      return "font/otf";
    case "pdf":
      return "application/pdf";
    case "php":
      return "application/x-httpd-php";
    case "png":
      return "image/png";
    case "ppt":
      return "application/vnd.ms-powerpoint";
    case "pptx":
      return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    case "rar":
      return "application/vnd.rar";
    case "rtf":
      return "application/rtf";
    case "sh":
      return "application/x-sh";
    case "svg":
      return "image/svg+xml";
    case "swf":
      return "application/x-shockwave-flash";
    case "tar":
      return "application/x-tar";
    case "tif":
      return "image/tiff";
    case "tiff":
      return "image/tiff";
    case "ts":
      return "video/mp2t";
    case "ttf":
      return "font/ttf";
    case "txt":
      return "text/plain";
    case "vsd":
      return "application/vnd.visio";
    case "wav":
      return "audio/wav";
    case "weba":
      return "audio/webm";
    case "webm":
      return "video/webm";
    case "webp":
      return "image/webp";
    case "woff":
      return "font/woff";
    case "woff2":
      return "font/woff2";
    case "xhtml":
      return "application/xhtml+xml";
    case "xls":
      return "application/vnd.ms-excel";
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "xml":
      return "application/xml text/xml";
    case "xul":
      return "application/vnd.mozilla.xul+xml";
    case "zip":
      return "application/zip";
    default:
      return "file";
  }
}
